import React from 'react';

const Error404 = () => (
  <div>
    <h2>error</h2>
    Error 404
  </div>
);

export default Error404;